import React from 'react'
import PropTypes from 'prop-types'

import { Breadcrumb } from '@aok/navigation'

import TemplateHeadline from '../TemplateHeadline/TemplateHeadline'
import ModuleContainer from '../../_layout/Module/ModuleContainer'

import { ColorScheme } from '../../../utils/defaultTypes'
import { pageHeaderPropTypes } from '../../../utils/commonPropTypes'

const PageHeader = ({ breadcrumb, theme, headline, abstract }) => {
  return (
    <div data-tracking-name="page-header" className={`${theme === ColorScheme.LIGHT ? 'bg-ffffff' : 'bg-005e3f'}`}>
      <ModuleContainer>
        {breadcrumb && <Breadcrumb items={breadcrumb} variant={theme} className="py-24" />}

        {headline?.text && <TemplateHeadline headline={headline} abstract={abstract} className="mt-48 1280:mt-80" />}
      </ModuleContainer>
    </div>
  )
}

PageHeader.propTypes = {
  breadcrumb: pageHeaderPropTypes.breadcrumb,
  theme: PropTypes.oneOf(Object.values(ColorScheme)),
  headline: pageHeaderPropTypes.headline,
  abstract: PropTypes.string,
}

PageHeader.defaultProps = {
  theme: ColorScheme.DARK,
}

export default PageHeader
